<template>
  <div class="container">
    <nav class="add-navigation">
      <div @click="$router.push({name: 'company-admin-company-info'})" class="back-link">
        <svg class="icon" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          ></path>
        </svg>
        <p>Back to Company Info</p>
      </div>
      <div class="buttons-wrapper">
        <div @click="$router.push({name: 'company-admin-company-info'})" class="secondary-button">
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button">
          <primary-button @click.native="editCompanyInfo">Edit company info</primary-button>
        </div>
      </div>
    </nav>
    <div class="add-container">
      <span class="container-title">Edit Company info</span>
      <div class="col-wrapper">
        <div class="col" v-if="company">
          <primary-input
            type="text"
            name="company name"
            class="field"
            v-model="company.company_name"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('first name')}"
            placeholder="Enter company name"
          />
          <div
            class="help is-danger"
            v-if="errors.has('company name')"
          >{{ errors.first('company name') }}</div>
          <primary-input
            type="text"
            name="country"
            class="field"
            v-model="countryName"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('first name')}"
            placeholder="Enter first country"
          />
          <div class="help is-danger" v-if="errors.has('country')">{{ errors.first('country') }}</div>
          <primary-input
            type="text"
            name="city"
            class="field"
            v-model="company.contact.city"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('first name')}"
            placeholder="Enter first city"
          />
          <div class="help is-danger" v-if="errors.has('city')">{{ errors.first('city') }}</div>
          <primary-input
            type="text"
            name="address"
            v-model="company.contact.address"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('first name')}"
            placeholder="Enter address"
          />
          <div class="help is-danger" v-if="errors.has('address')">{{ errors.first('address') }}</div>
          <primary-input
            type="text"
            name="state"
            v-model="company.contact.state"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('first name')}"
            placeholder="Enter state"
          />
          <div v-if="errors.has('state')" class="help is-danger">{{ errors.first('state') }}</div>
          <primary-input
            type="text"
            name="zipcode"
            v-model="company.contact.zipcode"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('first name')}"
            placeholder="Enter zipcode"
          />
          <div v-if="errors.has('zipcode')" class="help is-danger">{{ errors.first('zipcode') }}</div>
          <primary-input
                  type="password"
                  name="password"
                  @input="handlePassordChange"
                  v-model="company.contact.passwd"
                  placeholder="Password"
          />
        </div>
        <div class="col">
          <div class="dropzone-container">
            <p class="pimary-input-title">Change Photo</p>
            <app-dropzone
              ref="myVueDropzone"
              id="dropzone"
              @fileAdd="fileAdded($event)"
              class="dimension"
            ></app-dropzone>
            <div v-if="errors.has('file')" class="help is-danger">{{ errors.first('file') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import('@/components/Buttons/SecondaryButton.vue'),
    PrimaryButton: () => import('@/components/Buttons/PrimaryButton.vue'),
    AppDropzone: () => import('@/components/Dropzone'),
  },
  data: () => ({
    contactError: null,
    company: null,
    countryName: null,
    fileId: null,
    file: null,
    enabledUpload: true,
    changedPassword: null,
    currentCompanyInfo: {
      company_name: null,
        contact: {
          country_uuid: null,
          city: null,
          state: null,
          address: null,
          zipcode: null,
          logo_file_uuid: null,
          //file_uuid: null,
        },
    },
  }),
  created() {
    this.GetCompanyInfo();

  },
  methods: {
    handlePassordChange(value) {
      this.changedPassword = value;
    },
    GetCompanyInfo(){
      this.$store.dispatch('GetCompany', this.$store.getters.getUser.company_uuid).then( (res) => {
          this.company = res;
          this.$store.dispatch('UserGetCountry', this.company.contact.country_uuid).then( (res) => {
              this.countryName = res.nice_name // this.$store.getters.getCountry;
          })
          this.GetFile();
      });

    },
    GetFile() {
      console.log("this.company.contact.logo_file_uuid",this.company.contact.logo_file_uuid);
      // this.file = `http://88.198.219.62/api_smsc/v1/file/${this.company.contact.logo_file_uuid}`;
      var mockFile = { size: 1024, name: "Icon", type: "image/png" };
        this.$refs.myVueDropzone.$el.dropzone.emit("addedfile", mockFile);
        this.$refs.myVueDropzone.$el.dropzone.emit("thumbnail", mockFile, `http://88.198.219.62/api_smsc/v1/file/${this.company.contact.logo_file_uuid}`);
        this.$refs.myVueDropzone.$el.dropzone.emit("complete", mockFile);

      // this.$store.dispatch('GetFile', this.company.contact.logo_file_uuid).then((res) => {
      //   console.log("file res------->", res);
      //   this.file= res.data;

        // this.file = {
        //   name: res.data.name,
        //   size: res.data.size,
        //   accepted: true,
        //   kind: 'image',
        //   upload: {
        //     filename: res.data.name,
        //   },
        //   dataURL: res.data.base64,
        // }
        // console.log("filwee optionssssssssss",this.file);


      //this.$refs.myVueDropzone.manuallyAddFile(mockFile,'https://myvizo.com/img/logo_sm.png');

      // });
    },
    fileAdded(file) {
       if(file.accepted) {
          this.file = file;
          this.enabledUpload = false;
        }
    },
    uploadPhoto: async function() {
      let data = new FormData();

      data.append('file',this.file);
      data.append('belongs_to', 'user.logo');
      data.append('public', true);

      return await this.$store.dispatch('UploadFile', data);
    },
    editCompanyInfo: async function() {
      this.currentCompanyInfo.company_name = this.company.company_name;
      this.currentCompanyInfo.contact.city = this.company.contact.city;
      this.currentCompanyInfo.contact.address = this.company.contact.address;
      this.currentCompanyInfo.contact.zipcode = this.company.contact.zipcode;
      this.currentCompanyInfo.contact.state = this.company.contact.state;
      this.currentCompanyInfo.contact.logo_file_uuid = this.company.contact.logo_file_uuid;

      if (this.changedPassword) {
        this.currentCompanyInfo.contact.passwd = this.changedPassword;
      }

      let id = this.$store.getters.getUser.company_uuid;

      const valid = await this.$validator.validate();

      if (valid) {
        const countryList = await this.$store.dispatch('getCountryList', { nice_name: this.countryName});

        this.currentCompanyInfo.contact.country_uuid = countryList.items[0].country_uuid;

        if (this.file) {
          let res = await this.uploadPhoto();
          this.currentCompanyInfo.contact.logo_file_uuid = res.object_uuid;
          this.$store.commit("setProfilePath",`http://88.198.219.62/api_smsc/v1/file/${res.object_uuid}`);
        }

        try {
          await this.$store.dispatch("EditCompanyInfo", {
            companyInfo: this.currentCompanyInfo,
            id: id
          });

          this.$snotify.success("Company Info was edited.", {
            timeout: 6000
          });

          this.$router.push({ name: "company-admin-company-info" });
        } catch (err) {
          if (err.errors) {
              this.contactError = err.errors[0].company
                ? err.errors[0].contact
                : null;
              setTimeout(() => {
                this.contactError = null;
              }, 6000);
            } else {
               this.$snotify.error(
                 err.response.data.error.message
                 ? err.response.data.error.message
                 : err.response.data.errors,
                 {
                   timeout: 6000
                 }
              );
            }
        }
      }
    }
  }
};
</script>

<style lang="scss">
.container {
  font-family: "Helvetica Neue";
  padding: 0 20px;
  #dropzone {
    height: 400px;
    img {
      width: 300px;
      height: 260px;
    }
    .dz-details {
      width: 300px;
      height: 260px;
    }
    .dz-remove {
      width: 270px;
      height: 240px;
      margin-top: 15px;
      margin-bottom: 15px;
    }
  }
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 145px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    height: 620px;
    background-color: #ffffff;
    padding-top: 15px;
    .container-title {
      height: 30px;
      width: 432px;
      color: #000000;
      font-size: 18px;
      font-weight: 500;
      line-height: 30px;
      padding: 15px 0 15px 15px;
    }
    .col-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-left: 15px;
      margin-top: 20px;
      .col {
        width: 100%;
        padding-right: 15px;
        .dropzone-container {
          height: 100%;
        }
        .input {
          margin-bottom: 20px;
        }
        .field {
          p.pimary-input-title {
            color: #000000;
            font-family: "Helvetica Neue";
            font-size: 12px;
            font-weight: 900;
          }
        }
        .pimary-input-title {
          color: #000000;
          font-family: "Helvetica Neue";
          font-size: 12px;
          font-weight: 900;
          letter-spacing: 0.21px;
          line-height: 15px;
          margin-bottom: 5px;
          text-transform: uppercase;
        }
        .upload-contaioner {
          border: 1px solid #5171f3;
          border-radius: 4px;
          background-color: #ffffff;
          height: 276px;
          border-style: dashed;
          margin-right: 15px;
          position: relative;
          input[type="file"] {
            position: absolute;
            height: 36px;
            width: 136px;
            opacity: 0;
            cursor: pointer;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            -ms-transform: translate(-50%, -50%); /* IE 9 fix */
            z-index: 1;
          }
          .upload-button {
            height: 36px;
            width: 136px;
            border-radius: 4px;
            background-color: #51a3f3;
            margin: 0;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
    .email-input {
      margin-bottom: 20px;
    }
    .password-input {
      margin-bottom: 30px;
    }
    .first {
      margin-bottom: 30px;
      .remember-me {
        display: flex;
        align-items: center;
        input {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>

